module.exports = __webpack_public_path__ + "static/media/img_website.814a2ae5.jpg";